<template>
  <div
    class="row total-section pt-3 pb-3">
    <div
      class="col-6 text-left">
      <h4
        class="mb-0"
        style="font-weight:bold">{{ companyName }}</h4>
      <h4 class="mb-0">Total</h4>
    </div>
    <div
      class="col-6 text-right">
      <div class="d-inline-block align-middle">
        <h4
          class="mb-0"
          style="font-weight:bold">{{ time }}</h4>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: 'TotalTimeEntry',
  components: {},
  props: {
    companyName: {
      type: String,
      default: '',
    },
    time: {
      type: String,
      default: '',
    },
  },
  computed: {},
  methods: {},
};
</script>

<style scoped lang="scss">
div {
  &.row-item-transparent-with-border {
    padding: $top-menu-height 0;
    cursor: pointer;
  }
}
.total-section {
  background-color: $primary;
  border-bottom: 2px solid $secondary;
}
.total-section h4 {
  color: $base;
}
</style>
